// Publication dates in the manual table are rendered with moment's long-date
// format ('LL'). moment ships English only unless the locale is imported, so a
// Polish visitor would otherwise read "August 11, 2026" on an otherwise Polish
// page. Only the locales the portal offers are imported — importing the whole
// locale bundle would add far more weight than these twelve files.
import moment from 'moment';
import 'moment/locale/de';
import 'moment/locale/el';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/hu';
import 'moment/locale/it';
import 'moment/locale/pl';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/ru';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';

// i18n resource key -> moment locale name. moment uses its own naming for the
// Chinese variants, and English is its built-in default.
const MOMENT_LOCALE_BY_LANGUAGE = {
  de: 'de',
  el: 'el',
  en: 'en',
  es: 'es',
  fr: 'fr',
  hu: 'hu',
  it: 'it',
  pl: 'pl',
  ko: 'ko',
  jp: 'ja',
  ru: 'ru',
  zhchs: 'zh-cn',
  zhcht: 'zh-tw',
};

export const syncMomentLocale = (code) => {
  moment.locale(MOMENT_LOCALE_BY_LANGUAGE[code] || 'en');
};

export default syncMomentLocale;
